import React, { useState } from 'react'
import Slide from '@material-ui/core/Slide'
import Dialog from '@material-ui/core/Dialog'
import withStyles from '@material-ui/core/styles/withStyles'
import MuiDialogTitle from '@material-ui/core/DialogTitle'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import MuiDialogActions from '@material-ui/core/DialogActions'
import MuiButton from '@material-ui/core/Button'
import PropTypes from 'prop-types'

const styles = theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(2)
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500]
  }
})

const DialogActions = withStyles(theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(2)
  }
}))(MuiDialogActions)

const Button = withStyles({ root: { textTransform: 'none' } })(MuiButton)

const ConfirmModalDialog = ({
  message,
  hideBackdrop = true,
  confirmText = 'Confirm',
  confirmAction = null,
  cancelText = 'Cancel',
  cancelAction = () => {},
  pageToggleOverlay
}) => {
  const [open, setOpen] = useState(true)
  const handleCancel = () => {
    setOpen(false)
    pageToggleOverlay(null)
    cancelAction()
  }
  const handleConfirm = (e) => {
    e.preventDefault()
    setOpen(false)
    confirmAction()
  }

  return (
    <Dialog
      fullWidth
      hideBackdrop={hideBackdrop}
      keepMounted
      open={open}
      onClose={handleCancel}
      TransitionComponent={Slide}
    >
      <DialogTitle onClose={handleCancel}>
        <div className='f4 pr8'>
          {message
            .replace(/([.?!])\s*(?=[A-Z])/g, '$1|')
            .split('|')
            .map((sentence, index) => (
              <p key={index} className='ma0 mt6'>
                {sentence}
              </p>
            ))}
        </div>
      </DialogTitle>
      <DialogActions>
        {confirmAction &&
          <Button onClick={handleConfirm} color='primary' variant='contained'>
            {confirmText}
          </Button>}
        <Button onClick={handleCancel} color='primary' variant='contained'>
          {cancelText}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

const DialogTitle = withStyles(styles)(({ children, classes, onClose }) => (
  <MuiDialogTitle className={classes.root}>
    {children}
    <IconButton aria-label='close' className={classes.closeButton} onClick={onClose}>
      <CloseIcon />
    </IconButton>
  </MuiDialogTitle>
))

ConfirmModalDialog.propTypes = {
  message: PropTypes.node.isRequired,
  confirmText: PropTypes.string,
  cancelText: PropTypes.string,
  confirmAction: PropTypes.func,
  cancelAction: PropTypes.func
}

export default ConfirmModalDialog
